import { useTranslation } from 'react-i18next'
import { Button } from '@structural-climbing/ui'
import { SurfaceCard } from '../../design/SurfaceCard'

interface Props {
  /** Whether the subscription the payment bought has arrived yet. */
  hasPlan: boolean
  onDismiss: () => void
}

/**
 * What the member sees on the way back from Stripe.
 *
 * It confirms the payment and nothing else until the plan is actually on
 * screen. The webhook that writes the subscription runs on Stripe's clock, not
 * ours, so claiming the plan is active before we can see it would be a promise
 * the page cannot keep, and the hero right underneath would be contradicting it.
 */
export function PaymentReturnBanner({ hasPlan, onDismiss }: Props) {
  const { t } = useTranslation()

  return (
    <SurfaceCard elevated className="flex items-start gap-2 px-5 py-4">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-success">{t('payments.returnTitle')}</p>
        <p className="mt-0.5 text-sm text-foreground/55">
          {hasPlan ? t('payments.returnReady') : t('payments.returnPending')}
        </p>
      </div>
      <Button
        isIconOnly
        size="sm"
        variant="light"
        aria-label={t('common.close')}
        onClick={onDismiss}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="h-5 w-5 text-foreground/40"
        >
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </Button>
    </SurfaceCard>
  )
}
